import { com } from '@eidu/web'
import React from 'react'
import { Card, Stack, Text } from '@common/ui'
import EntityType = com.eidu.entity.type.EntityType
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import SemanticLink = com.eidu.entity.analytics.SemanticLink
import SemanticLinkId = com.eidu.entity.analytics.SemanticLinkId
import FieldType = com.eidu.entity.field.FieldType
import SemanticLinkItem from '../input/SemanticLinkItem'

type SemanticLinkDisplayProps = {
  entityTypeId: EntityTypeId
  entityTypes: readonly EntityType[]
  fieldType: FieldType
  semanticLinks: readonly SemanticLink[]
  onDelete?: (semanticLinkId: SemanticLinkId) => Promise<void>
}

const SemanticLinkDisplay = ({
  entityTypeId,
  entityTypes,
  fieldType,
  semanticLinks,
  onDelete,
}: SemanticLinkDisplayProps) => (
  <Stack gap="xs">
    {semanticLinks.length > 0 ? (
      semanticLinks.map(({ path, id: linkId }) => (
        <SemanticLinkItem
          key={linkId.toString()}
          linkId={linkId}
          path={path}
          entityTypeId={entityTypeId}
          entityTypes={entityTypes}
          onDelete={onDelete}
          fieldType={fieldType}
        />
      ))
    ) : (
      <Card>
        <Text>No links found</Text>
      </Card>
    )}
  </Stack>
)

export default SemanticLinkDisplay
